<template>
  <v-autocomplete
    v-model="selected"
    :items="items"
    :loading="loading"
    :search-input.sync="search"
    :label="label"
    clearable
    return-object
    hide-details
    hide-selected
    browser-autocomplete="nope"
    no-filter
    no-data-text="Данные не выбраны"
    :class="{ 'red lighten-4': selected && selected.isRemoved }"
    :menu-props="menuPropsClose"
    full-width
    height="40"
    outline
    prepend-inner-icon="person"
    clear-icon="close"
    @change="handleItemChange"
    @click:clear="clear"
    @click="closeMenuPropsOnClick(false)"
  >
    <template v-slot:append>
      <v-icon
        :title="'Редактировать'"
        :disabled="disabledEditBtn"
        @click="createNew"
      >
        edit
      </v-icon>
    </template>
  </v-autocomplete>
</template>
<script>
import CloseDropdownList from "../../../mixins/close-dropdown-list.js";
import { NestedEditorsEventBus } from "../../../components/nested-editors/nested-editors-event-bus.js";
import * as routesApi from "../../../backend/routesApi.js";

export default {
  mixins: [CloseDropdownList],
  props: ["value", "disabledEditBtn"],
  data() {
    return {
      selected: null,
      search: null,
      items: [],
      resource: "employees",
      componentName: "Employee",
      loading: false,
      label: "Логист",
    };
  },
  computed: {
    editableRouteInfoItem() {
      return this.$store.getters["route/editableRouteInfoItem"];
    },
  },
  watch: {
    value: {
      handler() {
        if (!this.value) {
          this.selected = null;
          this.search = null;
          this.items = [];
          return;
        }
        if (
          this.selected &&
          this.value.id === this.selected.value &&
          this.value.title === this.search
        ) {
          return;
        }
        const selectedItem = this.items.find(i => i.value === this.value.id);
        if (selectedItem) {
          this.selected = selectedItem;
          this.search = selectedItem.text;
        } else {
          this.setSelectedElement(this.value);
        }
      },
      deep: true,
    },
    search() {
      if (!this.search) {
        this.selected = null;
        this.fetchAll();
        return;
      }

      if (this.loading) {
        return;
      }

      if (this.selected && this.selected.text === this.search) {
        return;
      }

      this.loading = true;
      setTimeout(() => {
        if (!this.search) {
          this.selected = null;
          this.items = [];
          this.loading = false;
          return;
        }
        this.searchLogist();
        this.loading = false;
      }, 500);
    },
    editableRouteInfoItem: {
      handler() {
        if (!this.value) {
          this.selected = null;
        } else {
          this.setSelectedElement(this.value);
        }
      },
      deep: true,
    },
  },
  created() {
    if (this.value) {
      this.setSelectedElement(this.value);
    }
    NestedEditorsEventBus.$on("create-" + this._uid, createdId => {
      this.getLogistSelect(createdId);
    });
  },
  mounted() {
    this.$watch(
      () => {
        return this.$children[0].$data.isMenuActive;
      },
      newVal => {
        if (newVal) {
          this.fetchAll();
        } else {
          this.clear();
        }
      },
    );
  },
  methods: {
    handleItemChange() {
      this.$emit(
        "input",
        this.selected
          ? {
            id: this.selected.value,
            title: this.selected.text,
          }
          : null,
      );
    },
    async fetchAll() {
      this.items = await routesApi.fetchAllLogists(this.resource);
      this.loading = false;
    },
    clear() {
      this.items = [];
      if (this.selected) {
        this.items.push(this.selected);
      }
    },
    createNew() {
      this.closeMenuPropsOnClick(true);
      this.$emit("click");
      NestedEditorsEventBus.$emit("open", {
        title: this.label,
        uid: this._uid,
        component: this.componentName,
        params: this.selected,
        id: this.selected.value,
      });
    },
    setSelectedElement(value) {
      const newItem = {
        text: value.title,
        value: value.id,
        isRemoved: value.isRemoved,
      };
      this.selected = newItem;
      const item = this.items.find(i => i.value === newItem.value);
      if (item) {
        this.items.forEach(i => {
          if (i.value === newItem.value) {
            i.text = newItem.text;
          }
        });
      } else {
        this.items.push(this.selected);
      }
    },
    async getLogistSelect(id) {
      const logist = await routesApi.getLogistSelect(this.resource, id);
      await this.setSelectedElement(logist);
      this.handleItemChange();
    },
    async searchLogist() {
      this.items = await routesApi.searchLogist(this.resource, this.search);
    },
  },
};
</script>
